import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import "./Checkbox.css";

const _CheckBox = ({ color = "cyan", label = "text", checked = false }) => {
  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          checked={checked}
          sx={{
            color: color,
            "&.Mui-checked": {
              color: color,
            },
          }}
        />
      }
    />
  );
};
export default _CheckBox;
